import styled from '@emotion/styled';

export const FormWrapper = styled.div`
  visibility: ${({ formReady }: { formReady: boolean }) =>
    formReady ? 'visible' : 'hidden'};
`;
